import axios from "axios";
import { useEffect, useState } from "react";

export const useGetAIAnnoSuggestions = ({
  tagCategory,
  fieldValuePath,
  text,
  contentType,
  _id,
  fetchTrigger,
  showLogs = false,
}) => {
  const [state, setState] = useState({ data: undefined, status: "idle" });

  useEffect(() => {
    if (!fetchTrigger) return;

    // Each effect run gets its own `cancelled`. If fetchTrigger increments again before
    // this response arrives, React runs the cleanup (cancelled = true), so a stale
    // response from a previous trigger can't overwrite the latest result.
    let cancelled = false;
    setState({ data: undefined, status: "loading" });

    if (showLogs) console.log(`[AI_SUGGESTIONS] Fetching — field:${fieldValuePath} trigger:${fetchTrigger}`);

    axios
      .post("/api/aiAnnotation/getAIAnnoSuggestions", {
        tagCategory,
        text,
        metaData: { parentDocId: _id, contentType, fieldValuePath },
        showLogs,
      })
      .then((res) => {
        if (!cancelled) {
          if (showLogs) {
            const data = res.data;
            const count = Array.isArray(data) ? data.length : (data?.annotations?.length ?? 0);
            const fromCache = data?._fromCache;
            const source = fromCache === true ? "CACHE HIT" : "LLM";
            console.log(`[AI_SUGGESTIONS] ${source} — field:${fieldValuePath} count:${count}`);
          }
          setState({ data: res.data, status: "success" });
        }
      })
      .catch(() => {
        if (!cancelled) {
          if (showLogs) console.error(`[AI_SUGGESTIONS] Error — field:${fieldValuePath}`);
          setState({ data: undefined, status: "error" });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [fetchTrigger]);

  return state;
};
